<template>
  <b-modal
    id="cash-calc-modal"
    title="Cash Calculator"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    ok-only
    @ok="emitCloseModal"
    >
    <h3>Bills Received</h3>
    <b-row class="pt-2">
      <b-col><b-button size="lg" variant="outline-primary" @click="updateTotal(1)">$1</b-button></b-col>
      <b-col><b-button size="lg" variant="outline-primary" @click="updateTotal(5)">$5</b-button></b-col>
      <b-col><b-button size="lg" variant="outline-primary" @click="updateTotal(10)">$10</b-button></b-col>
      <b-col><b-button size="lg" variant="outline-primary" @click="updateTotal(20)">$20</b-button></b-col>
      <b-col><b-button size="lg" variant="outline-primary" @click="updateTotal(50)">$50</b-button></b-col>
    </b-row>
    <b-row class="pt-4">
      <b-col cols="1"></b-col>
      <b-col cols="3" style="font-size: 120%;">Money Received</b-col>
      <b-col cols="1"></b-col>
      <b-col cols="2" style="font-size: 120%;">Order Total</b-col>
      <b-col cols="1"></b-col>
      <b-col cols="3" style="font-size: 120%;">Change Needed</b-col>
      <b-col cols="1"></b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col cols="1"></b-col>
      <b-col cols="3">
        <b-form-input v-model="cashGiven"></b-form-input>
      </b-col>
      <b-col cols="1"> - </b-col>
      <b-col cols="2" style="font-size: 120%;">{{ order_total | toCurrency}}</b-col>
      <b-col cols="1"> = </b-col>
      <b-col cols="3" style="font-size: 120%; font-weight: bold; border-bottom: 2px solid black;">{{ changeNeeded | toCurrency }}</b-col>
      <b-col cols="1"></b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'CashCalculator',
  props: ['order_total'],
  data () {
    return {
      cashGiven: 0,
    }
  },

  computed: {
      changeNeeded: function() {
        return Number(Number(this.cashGiven).toFixed(2) - Number(this.order_total).toFixed(2));
      }
  },

  methods: {
    updateTotal(amnt) {
      this.cashGiven += Number(amnt);
    },

    emitCloseModal() {
      this.$emit('emit-close-modal');
    }
  },

  mounted() {
    this.$bvModal.show('cash-calc-modal');
  }
}
</script>

<style>

</style>
